import { useEffect } from 'react';
import type Player from 'video.js/dist/types/player';
import { disposePlayerAndNavigate, playerGoBack } from '../utils';

export function useRedirectOnVideoEnd({
  player,
  playableItem,
  baseURL,
  isPlayNext,
  isContinueWatchingSyncedFeed,
}: {
  player: Player;
  playableItem: any;
  baseURL: string;
  isPlayNext: boolean;
  isContinueWatchingSyncedFeed: boolean;
}) {
  useEffect(() => {
    if (!player || isPlayNext) return;

    const handleRedirectOnVideoEnd = () => {
      disposePlayerAndNavigate({
        player,
        isContinueWatchingSyncedFeed,
        navigationFunction: () => {
          playerGoBack({
            baseURL,
            playableItem,
          });
        },
      });
    };

    player.on('ended', handleRedirectOnVideoEnd);

    return () => {
      player.off('ended', handleRedirectOnVideoEnd);
    };
  }, [player, isPlayNext, playableItem]);
}
